import { C, BtnOrange, wrap, scrollTo } from '../styles';

export default function CTABanner() {
  return (
    <section style={{ padding: '80px 0', borderTop: `1px solid ${C.bdr}` }}>
      <div style={wrap}>
        <div style={{
          borderTop: `1px solid rgba(232,76,61,0.35)`,
          borderBottom: `1px solid rgba(232,76,61,0.35)`,
          padding: '64px 24px', textAlign: 'center', position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at center, rgba(50,151,219,0.08) 0%, transparent 70%)`, pointerEvents: 'none' }} />
          <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: C.orange, display: 'block', marginBottom: 12 }}>Ready to begin?</span>
          <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(28px, 5vw, 50px)', fontWeight: 700, textTransform: 'uppercase', color: C.txt, marginBottom: 14 }}>Submit your drawing today.</h2>
          <p style={{ color: C.mut, fontSize: 16, maxWidth: 460, margin: '0 auto 30px', lineHeight: 1.7 }}>
            No technical drawings required. No upfront engineering costs. Just a sketch and a clear description of what you need made.
          </p>
          <BtnOrange onClick={() => scrollTo('submit')}>Send Us Your Part</BtnOrange>
        </div>
      </div>
    </section>
  );
}
